import { Pipe, PipeTransform } from '@angular/core';

import { GridTableColumns } from '../modules/widget/components/widget-grid/widget-grid.component';

@Pipe({
  name: 'gridColumnPart',
  pure: false,
  standalone: false,
})
export class GridColumnPartPipe implements PipeTransform {
  transform(columnDef: string, columns: any, part: keyof GridTableColumns): any {
    return columns[columnDef]?.[part];
  }
}
